export class SelectedPump {
  public range: string = '';
  public size: string = '';
  public pressureStage: string = '';
  public maxDifferentialPressure: number | null = null;
  public baseSize: string = '';
  public rotor: string = '';
  public rotation: number = 1;

  public isValid(): boolean {
    return (
      this.range !== '' &&
      this.size !== '' &&
      this.pressureStage !== '' &&
      this.maxDifferentialPressure !== null &&
      this.baseSize !== '' &&
      this.rotor !== '' &&
      this.rotation >= 1 &&
      this.rotation <= 2
    );
  }
}
